import { useQuery } from '@tanstack/react-query';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { AxiosError } from 'axios';
import { apiClient } from '../../../api/client/axios';
import { showSnackbar } from '../../../store/snackbarSlice';

const fetchPricesByIds = async (query) => {
  const [, ids] = query.queryKey;
  const { data } = await apiClient.get('/prices', { params: { ids: ids.join(',') } });
  return data;
};

export const useGetPricesByIdsHandler = ({ ids = [] }) => {
  const dispatch = useDispatch();
  const [prices, setPrices] = useState([]);
  const normalizedIds = useMemo(
    () => Array.from(new Set((ids || []).map((id) => String(id || '').trim()).filter(Boolean))),
    [ids],
  );

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ['prices', normalizedIds],
    queryFn: fetchPricesByIds,
    enabled: normalizedIds.length > 0,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    refetchOnMount: 'always',
  });

  useEffect(() => {
    if (normalizedIds.length === 0) {
      setPrices([]);
      return;
    }
    if (data) {
      setPrices(data.data || []);
    }
  }, [data, normalizedIds.length]);

  useEffect(() => {
    if (!isError) return;
    if (error instanceof AxiosError) {
      dispatch(showSnackbar({ message: error.response?.data?.message || error.message, severity: 'error' }));
      return;
    }
    dispatch(showSnackbar({ message: JSON.stringify(error), severity: 'error' }));
  }, [dispatch, error, isError]);

  return { prices, isLoading };
};
